import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'
import React, { memo } from 'react'
import { Link } from 'react-router-dom'

import styles from './UserRow.module.sass'

const UserRow = memo(
	(props) => {
		const { data, className, ...attributes } = props
		const Tag = data.link ? Link : 'div'
		const to = data.link?.to
		const visibleRoles = data.roles.slice(0, 2)
		const extraRolesCount = Math.max(data.roles.length - 2, 0)
		return (
			<Tag
				{...attributes}
				className={`card ${styles['root'] || ''} ${className || ''} ${
					data.$isSelected ? styles['--selected'] : ''
				}`}
				to={to}
			>
				<span className={styles['avatar-container']}>
					<Avatar
						rounded
						className={styles['avatar']}
						user={data.avatar}
					/>
				</span>
				<div className={styles['container']}>
					<div className={styles['header']}>
						<small>
							<strong>{data.name}</strong>
						</small>
					</div>
					<div className={styles['body']}>
						{(data.roles || []).length ? (
							visibleRoles.map(({ name: role }, idx) => {
								return (
									<span
										key={idx}
										className={styles['user-role']}
										style={{
											maxWidth: `${
												100 /
												(visibleRoles.length +
													(extraRolesCount ? 1 : 0))
											}%`,
										}}
									>
										{role}
									</span>
								)
							})
						) : (
							<small className={styles['message']}>
								{data.$cardLabels.noRoles}
							</small>
						)}
						{extraRolesCount > 0 && (
							<span className={styles['user-role']}>
								+{extraRolesCount}
							</span>
						)}
					</div>
				</div>
			</Tag>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.style.top === nextProps.style.top &&
		prevProps.data.$isSelected === nextProps.data.$isSelected
)

UserRow.defaultHeight = 91

export const UserRowSkeleton = (props) => {
	const { className, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['row-skeleton']} ${className || ''}`}
		>
			<span className={styles['icon']}>
				<Skeleton className={styles['skeleton']} />
			</span>
			<span>
				<h5>
					<Skeleton
						className={`${styles['skeleton']} ${styles['smaller']}`}
					/>
				</h5>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
			<span className={styles['process']}>
				<small>
					<Skeleton className={styles['skeleton']} />
				</small>
			</span>
			<span>
				<small>
					<Skeleton
						className={`${styles['skeleton']} ${styles['small']}`}
					/>
				</small>
			</span>
		</div>
	)
}

export default UserRow
